import { render } from "./SignListComponent.vue?vue&type=template&id=b2bfcc04&scoped=true"
import script from "./SignListComponent.vue?vue&type=script&lang=js"
export * from "./SignListComponent.vue?vue&type=script&lang=js"

import "./SignListComponent.vue?vue&type=style&index=0&id=b2bfcc04&lang=scss&scoped=true"

import exportComponent from "/Users/zhanglinjun/Downloads/genescloud_wechat-master-d167e5133fddc18883d58aba5b516d53ee974944/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2bfcc04"]])

export default __exports__